import { motion } from "framer-motion";
import { Plane } from "lucide-react";

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="flex flex-col items-center gap-8">
        {/* Animated Logo */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="relative"
        >
          {/* Radar circles */}
          <motion.div
            className="absolute inset-0 w-32 h-32 border border-primary/20 rounded-full"
            animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0, 0.5] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
          <motion.div
            className="absolute inset-0 w-32 h-32 border border-primary/30 rounded-full"
            animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0, 0.5] }}
            transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
          />
          
          {/* Center plane icon */}
          <div className="w-32 h-32 flex items-center justify-center bg-slate-900/50 rounded-full border border-slate-800">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
            >
              <Plane className="w-12 h-12 text-primary" />
            </motion.div>
          </div>
        </motion.div>

        {/* Brand name */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-center"
        >
          <h1 className="text-2xl font-bold tracking-widest text-primary">
            AEROCORE
          </h1>
          <p className="text-xs tracking-[0.3em] text-muted-foreground mt-1">
            SCRIPTS
          </p>
        </motion.div>

        {/* Loading bar */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          className="h-[2px] bg-gradient-to-r from-transparent via-primary to-transparent w-48"
        />

        {/* Loading text */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="text-xs tracking-widest text-muted-foreground uppercase"
        >
          Loading System
        </motion.p>
      </div>
    </div>
  );
};

export default LoadingScreen;
